const redactUniqueIDs = (path: string): string => {
  const regexPattern = /([^/]{46})/g;

  return path.replace(regexPattern, '_');
};

export default redactUniqueIDs;
